import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useIndicatorAnalyzeFilters } from 'business/shift-report/indicators/pages/indicator-analyze/providers/filters';
import config from 'config';
import AppLogo from 'ui/appLogo';

import styles from './index.module.scss';

export const IndicatorAnalyzePrintHeader = () => {
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No constructionSite');

  const { t } = useTranslation();

  const filters = useIndicatorAnalyzeFilters();

  const dates =
    filters.filterType === 'date' &&
    filters.dateRange &&
    filters.dateRange[0] &&
    filters.dateRange[1]
      ? [filters.dateRange[0].format('L'), filters.dateRange[1].format('L')]
      : undefined;

  const logo = currentConstructionSite.logo;

  return (
    <div className={styles.printHeader}>
      <div className="header-left">
        <AppLogo />
        {logo ? (
          <AppLogo
            alt="Construction site logo"
            path={`${config.gcp.publicUri}/${logo}`}
          />
        ) : null}
      </div>
      <h1>{currentConstructionSite.name}</h1>
      {dates ? (
        <h2>
          {t('pages.print.rangeTitle', {
            startDate: dates[0],
            endDate: dates[1],
          })}
        </h2>
      ) : null}
    </div>
  );
};
